import * as React from "react";
import Helmet from "@/components/Helmet";
import { useTheme } from "@/hooks/useTheme";
import SetupContract from "@/components/SetupContract";
import NewIndexPage from "@/components/pages/new/index";
import { useGoogleTagManagerId } from "@/hooks/useGoogleTagManagerId";

const IndexPage = () => {
  const { isNewTheme } = useTheme();
  const { googleTagManagerId } = useGoogleTagManagerId();

  return (
    <SetupContract useExpired>
      <Helmet
        title="AI査定ツール | 査定申し込み"
        meta={[{ name: "robots", content: "noindex,nofollow" }]}
        googleTagManagerId={googleTagManagerId}
      />
      <NewIndexPage />
    </SetupContract>
  );
};

export default IndexPage;
